import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

// Image imports
import bnm from "../../Assets/Projects/4Logo.png";
import bromlee from "../../Assets/Projects/8Logo.png";
import personal from "../../Assets/Projects/3Logo.png";
import trolley from "../../Assets/Projects/1Logo.png";
import redcut from "../../Assets/Projects/7Logo.png";
import fitness from "../../Assets/Projects/2Logo.png";
import red from "../../Assets/Projects/6Logo.png";
import jackleth from "../../Assets/Projects/5Logo.png";
import classic from "../../Assets/Projects/12Logo.png";
import pharma from "../../Assets/Projects/11Logo.png";
import laundry from "../../Assets/Projects/10Logo.png";
import premium from "../../Assets/Projects/9Logo.png";

// Project Data
const projects = [
  {
    imgPath: trolley,
    title: "Trolley Easy Shopping",
    description:
      "E-commerce platform offering a wide range of household and personal care products. Built with Vue.js, Bootstrap, jQuery, PHP, and MySQL.",
    demoLink: "https://trolley.com.pk/",
  },
  {
    imgPath: fitness,
    title: "Fitness Trolley",
    description:
      "WooCommerce store focused on wellness and beauty products. Built with WordPress, Bootstrap, jQuery, PHP, and MySQL.",
    demoLink: "https://fitness.trolley.com.pk/",
  },
  {
    imgPath: personal,
    title: "Personal Care Trolley",
    description:
      "E-commerce site for personal care essentials using WordPress & WooCommerce, built with Bootstrap, jQuery, PHP, and MySQL.",
    demoLink: "https://personalcare.trolley.com.pk/",
  },
  {
    imgPath: bnm,
    title: "BNM Store",
    description:
      "Shopify-based store for smart living products like kitchen tools, bathware, and health & beauty items.",
    demoLink: "https://bnmstore.com/",
  },
  {
    imgPath: redcut,
    title: "Redcut Toys",
    description:
      "E-commerce platform for educational toys. Built with Bootstrap, jQuery, PHP, and MySQL.",
    demoLink: "https://toys.redcut.com.pk/",
  },
  {
    imgPath: bromlee,
    title: "Bromlee Limited UK",
    description:
      "Shopify-based UK store with minimalistic design and seamless shopping experience.",
    demoLink: "https://bromlee.com/",
  },
  {
    imgPath: red,
    title: "Red Cut",
    description:
      "E-commerce site for children's toys. Backend built with PHP and MySQL.",
    demoLink: "https://redcut.com.pk/",
  },
  {
    imgPath: jackleth,
    title: "Jack Leth",
    description:
      "E-commerce store for educational and creative toys. Backend: PHP & MySQL.",
    demoLink: "https://jackleth.pk/",
  },
  {
    imgPath: classic,
    title: "Classic Store",
    description:
      "E-commerce platform built with Shopify, offering a smooth shopping experience.",
    demoLink: "http://classicstore.pk/",
  },
  {
    imgPath: pharma,
    title: "RT Pharma",
    description:
      "Shopify-based pharma store with a focus on medicines. Backend: PHP & MySQL.",
    demoLink: "https://rtpharma.com.pk/",
  },
  {
    imgPath: laundry,
    title: "Laundry Wave",
    description:
      "Shopify-based laundry service store. Backend powered by PHP and MySQL.",
    demoLink: "https://laundry.ware.pk/",
  },
  {
    imgPath: premium,
    title: "3D Premium",
    description:
      "E-commerce store built with Shopify, offering various household products.",
    demoLink: "https://3dpremium.pk/",
  },
];

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h2 className="project-heading">
          <strong className="purple">OUR PORTFOLIO</strong>
        </h2>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {projects.map((project, index) => (
            <Col md={4} className="project-card" key={index}>
              <ProjectCard
                imgPath={project.imgPath}
                isBlog={false}
                title={project.title}
                description={project.description}
                demoLink={project.demoLink}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
